module.exports = __webpack_public_path__ + "img/Facebook-black.9b487e0e.svg";